import { SxProps } from '@mui/material';

export const createdAtBox: SxProps = {
  color: 'gray',
  textAlign: 'right',
};
